/* eslint-disable camelcase */

import axios from 'axios';
import type { SiteDTO } from '@hotjar/site';
import type { SessionsSettings, BlockedIp } from './types';

type Response = {
  success: boolean;
  errorMessage?: string;
};

type SessionsSettingsAction = 'update_session_capture_mode' | 'update_session_settings';

interface SiteApi {
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  put: (
    accountId: number,
    siteId: number,
    section: string,
    data: Partial<SiteDTO>,
  ) => Promise<Response>;
}

interface SessionsSettingsApi {
  get: (siteId: number) => Promise<Response & { data?: Partial<SessionsSettings> }>;
  post: (
    siteId: number,
    action: SessionsSettingsAction,
    data: Partial<SessionsSettings>,
  ) => Promise<Response>;
}

interface IpBlockingApi {
  get: (organizationId: number) => Promise<Response & { data?: BlockedIp[] }>;
  post: (
    organizationId: number,
    data: BlockedIp[] | null,
  ) => Promise<Response & { data?: { ignored_ips: BlockedIp[] } }>;
}

export const siteApi: SiteApi = {
  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  put: async (accountId, siteId, section, data) => {
    try {
      const response = await axios.put(
        `/api/v1/accounts/${accountId}/sites/${siteId}?section=${section}`,
        data,
      );

      return {
        success: response.data.success as boolean,
        errorMessage: response.data.error as string,
      };
    } catch (error) {
      return {
        success: false,
        errorMessage: 'Request error',
      };
    }
  },
};

export const sessionsSettingsApi: SessionsSettingsApi = {
  get: async (siteId) => {
    try {
      const response = await axios.get(`/api/v1/sites/${siteId}/settings/sessions`);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        errorMessage: 'Request error',
      };
    }
  },
  post: async (siteId, action, data) => {
    try {
      const response = await axios.post(`/api/v1/sites/${siteId}/settings/sessions`, {
        ...data,
        action,
      });

      return {
        success: response.data.success as boolean,
        errorMessage: response.data.error as string,
      };
    } catch (error) {
      return {
        success: false,
        errorMessage: 'Request error',
      };
    }
  },
};

export const ipBlockingApi: IpBlockingApi = {
  get: async (organizationId) => {
    try {
      const response = await axios.get(`/api/v1/organizations/${organizationId}/ignored-ips`);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        errorMessage: 'Request error',
      };
    }
  },
  post: async (organizationId, data) => {
    try {
      const response = await axios.post(`/api/v1/organizations/${organizationId}/ignored-ips`, {
        ips: data || [],
      });

      return {
        success: response.data.success as boolean,
        errorMessage: response.data.error as string,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        errorMessage: 'Request error',
      };
    }
  },
};
